import { DataSystemDetails } from '@ketch-com/windlass/dist/dataSentry/v1/systems/systems'

export function getSystemName(system: DataSystemDetails): string {
  return system?.name || system?.code || 'Unknown'
}
